import * as styles from "@/styles/modules/Rows.module.scss"

interface RowsProps {
  className?: string
  gap: number
  justify?: React.CSSProperties["justifyContent"]
}

const Rows = ({
  children,
  className,
  gap,
  justify,
}: React.PropsWithChildren<RowsProps>) => {
  return (
    <div
      className={`${styles.wrapper} ${styles["gap" + gap]} ${
        className ? className : ""
      }`}
      style={justify ? { justifyItems: justify } : undefined}
    >
      {children}
    </div>
  )
}

export default Rows
